module.exports = __webpack_public_path__ + "img/bri_bak.ef299542.png";